import { render, staticRenderFns } from "./MerchantAnnouncement.vue?vue&type=template&id=77ba13af&"
import script from "./MerchantAnnouncement.vue?vue&type=script&lang=js&"
export * from "./MerchantAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports